.row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  min-height: 44px;
}

.row:hover,
.row[data-highlighted='true'] {
  background: var(--tuna-palette-action-hover);
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: var(--tuna-shape-radius-circle);
  background: var(--tuna-palette-primary-light);
  color: var(--tuna-palette-primary-contrastText);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--tuna-typography-fontSize-xs);
  flex: 0 0 auto;
  text-transform: uppercase;
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.name {
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email {
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.2;
  color: var(--tuna-palette-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
